module.exports = __webpack_public_path__ + "img/dianzibaohan@3x.ec295e93.png";